var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspectionIng(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 109,
    viewBox: "0 0 103 109",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_973_2527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4972 8.47244C49.1668 8.47244 47.2785 6.57754 47.2785 4.23915C47.2785 1.90076 49.1668 0.00585909 51.4972 0.00585919C53.8275 0.00585929 55.7158 1.90076 55.7158 4.23915C55.7158 6.57754 53.8275 8.47244 51.4972 8.47244Z",
    fill: "url(#paint0_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4773 12.7804C33.4569 13.9496 30.8798 13.2584 29.7089 11.2311C28.5438 9.20369 29.2325 6.61764 31.2529 5.44845C33.2733 4.27925 35.8561 4.9704 37.0213 6.99777C38.1864 9.02514 37.4977 11.617 35.4773 12.7804Z",
    fill: "url(#paint1_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7518 24.5475C22.5866 26.5748 20.0037 27.266 17.9891 26.0968C15.9687 24.9276 15.28 22.3358 16.4451 20.3142C17.6103 18.2868 20.1932 17.5957 22.2078 18.7649C24.2282 19.934 24.9169 22.5259 23.7518 24.5532L23.7518 24.5475Z",
    fill: "url(#paint2_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.458 40.6224C19.458 42.9608 17.5696 44.8557 15.2393 44.8557C12.909 44.8557 11.0207 42.9608 11.0207 40.6224C11.0207 38.2841 12.909 36.3892 15.2393 36.3892C17.5696 36.3892 19.458 38.2841 19.458 40.6224Z",
    fill: "url(#paint3_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7518 56.6971C24.9169 58.7245 24.2282 61.3163 22.2078 62.4855C20.1874 63.6547 17.6103 62.9578 16.4451 60.9361C15.28 58.9088 15.9687 56.317 17.9891 55.1535C20.0095 53.9843 22.5923 54.6755 23.7575 56.7028L23.7518 56.6971Z",
    fill: "url(#paint4_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4773 68.4641C37.4977 69.6333 38.1864 72.2251 37.0213 74.2524C35.8561 76.2798 33.2733 76.971 31.2529 75.8018C29.2325 74.6326 28.5438 72.0408 29.7089 70.0134C30.8741 67.986 33.4569 67.2949 35.4716 68.4641L35.4773 68.4641Z",
    fill: "url(#paint5_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4973 72.7724C53.8276 72.7724 55.7217 74.6673 55.7217 77.0057C55.7217 79.344 53.8333 81.2389 51.4973 81.2389C49.1612 81.2389 47.2786 79.344 47.2786 77.0057C47.2786 74.6673 49.167 72.7666 51.4973 72.7666L51.4973 72.7724Z",
    fill: "url(#paint6_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5166 68.4641C69.5369 67.2949 72.1198 67.986 73.285 70.0134C74.4501 72.0408 73.7614 74.6326 71.741 75.8018C69.7206 76.971 67.1435 76.2798 65.9783 74.2524C64.8132 72.2251 65.5019 69.6333 67.5223 68.4641L67.5166 68.4641Z",
    fill: "url(#paint7_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2421 56.6975C80.4073 54.6701 82.9901 53.979 85.0105 55.1482C87.0309 56.3173 87.7196 58.9092 86.5545 60.9365C85.3893 62.9639 82.8065 63.655 80.7918 62.4859C78.7715 61.3167 78.0827 58.7249 79.2479 56.6975L79.2421 56.6975Z",
    fill: "url(#paint8_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5353 40.6223C83.5353 38.284 85.4237 36.3833 87.754 36.3833C90.0843 36.3833 91.9727 38.2782 91.9727 40.6223C91.9727 42.9665 90.0843 44.8556 87.754 44.8556C85.4237 44.8556 83.5296 42.9607 83.5296 40.6223L83.5353 40.6223Z",
    fill: "url(#paint9_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2479 24.5474C78.0827 22.52 78.7715 19.9282 80.7918 18.759C82.8122 17.5898 85.3893 18.2809 86.5545 20.3083C87.7196 22.3357 87.0309 24.9217 85.0105 26.0909C82.9901 27.2601 80.413 26.569 79.2479 24.5416L79.2479 24.5474Z",
    fill: "url(#paint10_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5166 12.7804C65.4962 11.6112 64.8074 9.01938 65.9726 6.99777C67.1378 4.9704 69.7206 4.27925 71.741 5.44845C73.7614 6.61764 74.4501 9.20945 73.285 11.2311C72.1198 13.2584 69.5369 13.9496 67.5223 12.7804L67.5166 12.7804Z",
    fill: "url(#paint11_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4972 36.2278C49.1668 36.2278 47.2785 34.3329 47.2785 31.9945C47.2785 29.6561 49.1668 27.7612 51.4972 27.7612C53.8275 27.7612 55.7158 29.6561 55.7158 31.9945C55.7158 34.3329 53.8275 36.2278 51.4972 36.2278Z",
    fill: "url(#paint12_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4773 40.5358C33.4569 41.705 30.8798 41.0138 29.7089 38.9864C28.5438 36.9591 29.2325 34.373 31.2529 33.2038C33.2733 32.0346 35.8561 32.7258 37.0213 34.7531C38.1864 36.7805 37.4977 39.3723 35.4773 40.5358Z",
    fill: "url(#paint13_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7518 52.3028C22.5866 54.3302 20.0037 55.0214 17.9891 53.8522C15.9687 52.683 15.28 50.0912 16.4451 48.0696C17.6103 46.0422 20.1932 45.351 22.2078 46.5202C24.2282 47.6894 24.9169 50.2812 23.7518 52.3086L23.7518 52.3028Z",
    fill: "url(#paint14_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.458 68.3778C19.458 70.7162 17.5696 72.6111 15.2393 72.6111C12.909 72.6111 11.0207 70.7162 11.0207 68.3778C11.0207 66.0394 12.909 64.1445 15.2393 64.1445C17.5696 64.1445 19.458 66.0394 19.458 68.3778Z",
    fill: "url(#paint15_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7518 84.4525C24.9169 86.4798 24.2282 89.0716 22.2078 90.2408C20.1874 91.41 17.6103 90.7131 16.4451 88.6915C15.28 86.6641 15.9687 84.0723 17.9891 82.9089C20.0095 81.7397 22.5923 82.4309 23.7575 84.4582L23.7518 84.4525Z",
    fill: "url(#paint16_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4773 96.2194C37.4977 97.3886 38.1864 99.9804 37.0213 102.008C35.8561 104.035 33.2733 104.726 31.2529 103.557C29.2325 102.388 28.5438 99.7961 29.7089 97.7688C30.8741 95.7414 33.4569 95.0502 35.4716 96.2194L35.4773 96.2194Z",
    fill: "url(#paint17_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4973 100.528C53.8276 100.528 55.7217 102.423 55.7217 104.761C55.7217 107.099 53.8333 108.994 51.4973 108.994C49.1612 108.994 47.2786 107.099 47.2786 104.761C47.2786 102.423 49.167 100.522 51.4973 100.522L51.4973 100.528Z",
    fill: "url(#paint18_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5166 96.2194C69.5369 95.0502 72.1198 95.7414 73.285 97.7688C74.4501 99.7961 73.7614 102.388 71.741 103.557C69.7206 104.726 67.1435 104.035 65.9783 102.008C64.8132 99.9804 65.5019 97.3886 67.5223 96.2194L67.5166 96.2194Z",
    fill: "url(#paint19_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2421 84.4529C80.4073 82.4255 82.9901 81.7343 85.0105 82.9035C87.0309 84.0727 87.7196 86.6645 86.5545 88.6919C85.3893 90.7193 82.8065 91.4104 80.7918 90.2412C78.7715 89.072 78.0827 86.4802 79.2479 84.4529L79.2421 84.4529Z",
    fill: "url(#paint20_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5353 68.3777C83.5353 66.0393 85.4237 64.1387 87.754 64.1387C90.0843 64.1387 91.9727 66.0336 91.9727 68.3777C91.9727 70.7219 90.0843 72.611 87.754 72.611C85.4237 72.611 83.5296 70.7161 83.5296 68.3777L83.5353 68.3777Z",
    fill: "url(#paint21_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2479 52.3027C78.0827 50.2754 78.7715 47.6836 80.7918 46.5144C82.8122 45.3452 85.3893 46.0363 86.5545 48.0637C87.7196 50.0911 87.0309 52.6771 85.0105 53.8463C82.9901 55.0155 80.413 54.3244 79.2479 52.297L79.2479 52.3027Z",
    fill: "url(#paint22_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5166 40.5358C65.4962 39.3666 64.8074 36.7748 65.9726 34.7531C67.1378 32.7258 69.7206 32.0346 71.741 33.2038C73.7614 34.373 74.4501 36.9648 73.285 38.9864C72.1198 41.0138 69.5369 41.705 67.5223 40.5358L67.5166 40.5358Z",
    fill: "url(#paint23_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.49999 80.7516L0.499992 28.2484C0.499992 24.2523 3.73718 21 7.71479 21L95.2852 21C99.2628 21 102.5 24.2523 102.5 28.2484L102.5 80.7516C102.5 84.7477 99.2628 88 95.2852 88L7.71479 88C3.73718 88 0.49999 84.7477 0.49999 80.7516ZM97.9082 28.2484C97.9082 26.7952 96.7316 25.6131 95.2852 25.6131L7.71479 25.6131C6.26839 25.6131 5.09174 26.7952 5.09174 28.2484L5.09174 80.7516C5.09174 82.2047 6.26838 83.3869 7.71479 83.3869L95.2852 83.3869C96.7316 83.3869 97.9082 82.2047 97.9082 80.7516L97.9082 28.2484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5 28.832L99.5 80.168C99.5 82.8349 97.3278 85 94.6522 85L8.34781 85C5.67219 85 3.5 82.8349 3.5 80.168L3.5 28.832C3.5 26.1651 5.67219 24 8.34781 24L94.6522 24C97.3278 24 99.5 26.1651 99.5 28.832Z",
    fill: "#424052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0197 60.5195H31.3203V76.8112H37.0197V60.5195Z",
    fill: "url(#paint24_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4181 45.6445H42.7188V76.8112H48.4181V45.6445Z",
    fill: "url(#paint25_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1017 52.7266H53.4023V76.8099H59.1017V52.7266Z",
    fill: "url(#paint26_linear_973_2527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5001 32.1875H64.8008V76.8125H70.5001V32.1875Z",
    fill: "url(#paint27_linear_973_2527)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_973_2527",
    x1: 48.9857,
    y1: 0.898625,
    x2: 57.665,
    y2: 12.3717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_973_2527",
    x1: 30.8512,
    y1: 5.77291,
    x2: 39.5315,
    y2: 17.2551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_973_2527",
    x1: 17.5862,
    y1: 19.0893,
    x2: 26.2681,
    y2: 30.5658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_973_2527",
    x1: 12.7279,
    y1: 37.2819,
    x2: 21.4072,
    y2: 48.7551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_973_2527",
    x1: 17.5862,
    y1: 55.4779,
    x2: 26.2665,
    y2: 66.9539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_973_2527",
    x1: 30.8512,
    y1: 68.7891,
    x2: 39.539,
    y2: 80.2734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_973_2527",
    x1: 48.987,
    y1: 73.66,
    x2: 57.6722,
    y2: 85.1409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_973_2527",
    x1: 67.1194,
    y1: 68.7891,
    x2: 75.8088,
    y2: 80.2678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_973_2527",
    x1: 80.389,
    y1: 55.4732,
    x2: 89.0784,
    y2: 66.9518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_973_2527",
    x1: 85.2379,
    y1: 37.2767,
    x2: 93.9232,
    y2: 48.7576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_973_2527",
    x1: 80.389,
    y1: 19.0835,
    x2: 89.0708,
    y2: 30.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_973_2527",
    x1: 67.1149,
    y1: 5.77291,
    x2: 75.7951,
    y2: 17.2551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_973_2527",
    x1: 48.9857,
    y1: 28.654,
    x2: 57.665,
    y2: 40.1271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_973_2527",
    x1: 30.8512,
    y1: 33.5283,
    x2: 39.5315,
    y2: 45.0105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_973_2527",
    x1: 17.5862,
    y1: 46.8447,
    x2: 26.2681,
    y2: 58.3212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_973_2527",
    x1: 12.7279,
    y1: 65.0373,
    x2: 21.4072,
    y2: 76.5104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_973_2527",
    x1: 17.5862,
    y1: 83.2332,
    x2: 26.2665,
    y2: 94.7093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_973_2527",
    x1: 30.8512,
    y1: 96.5445,
    x2: 39.539,
    y2: 108.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_973_2527",
    x1: 48.987,
    y1: 101.415,
    x2: 57.6722,
    y2: 112.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_973_2527",
    x1: 67.1194,
    y1: 96.5445,
    x2: 75.8088,
    y2: 108.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_973_2527",
    x1: 80.389,
    y1: 83.2286,
    x2: 89.0784,
    y2: 94.7072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_973_2527",
    x1: 85.2379,
    y1: 65.032,
    x2: 93.9232,
    y2: 76.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_973_2527",
    x1: 80.389,
    y1: 46.8388,
    x2: 89.0708,
    y2: 58.3153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_973_2527",
    x1: 67.1149,
    y1: 33.5283,
    x2: 75.7951,
    y2: 45.0105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_973_2527",
    x1: 28.3537,
    y1: 73.2977,
    x2: 39.6768,
    y2: 59.8391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FFE4EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_973_2527",
    x1: 43.0422,
    y1: 76.8681,
    x2: 51.406,
    y2: 45.5199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_973_2527",
    x1: 52.9929,
    y1: 76.8598,
    x2: 60.8567,
    y2: 51.9578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_973_2527",
    x1: 64.8982,
    y1: 77.298,
    x2: 72.0924,
    y2: 31.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FFE4EB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_973_2527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 102,
    fill: "white",
    transform: "translate(102.5) rotate(90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectionIng);
export default __webpack_public_path__ + "static/media/inspection_ing.853180fb88143def99cb5af1849d3a40.svg";
export { ForwardRef as ReactComponent };